import type { IWidgetComponentProps } from '~packages/engine/src/schema/widgets/IWidgetType';
import { IPageWidget } from './IPageWidget';

export interface IPageWidgetComponentProps
  extends IWidgetComponentProps<IPageWidget> {}

export function PageWidgetComponent(props: IPageWidgetComponentProps) {
  // il componente non sarà visualizzato
  // serve solo come indicazione di Page Break per creare le pagine dello stepper
  return null;
}
